class BlogCarousel extends HTMLElement {
	constructor() {
		super();

    this.initialized = false;
		this.uniqueClass = `.splide--${this.dataset.id}`;
		this.splideType = this.dataset.splideType || 'slide';
    this.slidesPerPageDesktop = parseInt(this.dataset.slidesPerPageDesktop, 10) || 4;
    this.slidesPerPageTablet = parseInt(this.dataset.slidesPerPageTablet, 10) || 3;
    this.slidesPerPageMobile = parseInt(this.dataset.slidesPerPageMobile, 10) || 1;
    this.showPagination = this.dataset.showPagination === 'true';

	}

	connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
		this.init();
	}

	init() {
    const totalSlides = this.querySelectorAll('.splide__slide').length;

    // Adjust slides per page based on the number of available items
    const perPageDesktop = Math.min(this.slidesPerPageDesktop, totalSlides);
    const perPageTablet = Math.min(this.slidesPerPageTablet, totalSlides);
    const perPageMobile = Math.min(this.slidesPerPageMobile, totalSlides);

		const splide = new Splide(this.uniqueClass, {
			type: this.splideType,
			gap: '20px',
			arrows: false, // Disable default arrows; using custom ones
			pagination: this.showPagination && totalSlides > perPageDesktop,
      perPage: perPageDesktop,
      classes: {
        pagination: 'splide__pagination blog-posts-selected__pagination',
        page: 'splide__pagination__page blog-posts-selected__pagination-dot',
      },
			breakpoints: {
				1200: {
          perPage: perPageTablet,
				},
				768: {
          perPage: perPageMobile,
				},
			},
		});

    if (this.showPagination && totalSlides > perPageDesktop) {
      splide.on('pagination:mounted', (data) => {
        data.items.forEach((item, index) => {
          item.button.innerHTML = `
            <span class="blog-posts-selected__pagination-icon" aria-hidden="true">
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5 0L15.5 7.5L23 11.5L15.5 15.5L11.5 23L7.5 15.5L0 11.5L7.5 7.5L11.5 0Z" fill="currentColor"/>
              </svg>
            </span>
          `;
          item.button.setAttribute('aria-label', `Go to slide ${index + 1}`);
        });
      });
    }

    splide.mount();

    // Select the custom arrow buttons
    const prevArrow = this.querySelector('.splide__arrow--prev');
    const nextArrow = this.querySelector('.splide__arrow--next');

    // Update arrow states
    const updateArrowStates = () => {
      if (splide.index === 0) {
        prevArrow.classList.add('is-disabled');
        prevArrow.setAttribute('disabled', true);
      } else {
        prevArrow.classList.remove('is-disabled');
        prevArrow.removeAttribute('disabled');
      }

      if (splide.index >= splide.length - splide.options.perPage) {
        nextArrow.classList.add('is-disabled');
        nextArrow.setAttribute('disabled', true);
      } else {
        nextArrow.classList.remove('is-disabled');
        nextArrow.removeAttribute('disabled');
      }
    };

    // Initial arrow state check
    updateArrowStates();

    // Listen to slide changes to update arrow states
    splide.on('moved', updateArrowStates);

    // Manually control the custom arrows
    prevArrow.addEventListener('click', () => {
			splide.go('<');
		});

    nextArrow.addEventListener('click', () => {
			splide.go('>');
		});
	}
}

customElements.define('blog-carousel', BlogCarousel);
